module.exports = __webpack_public_path__ + "static/media/sendQuery.ebf32b88.svg";